import {
  AdvancedFilterDataSchema,
  FilterGroupSchema,
} from "@redotech/redo-views-common/advanced-filters/advanced-filter-data";
import * as z from "zod";

export const DEFAULT_MAX_WORK_ORDERS_PER_SESSION = 20;
export const DEFAULT_MAX_PICK_LINES_PER_SESSION = 200;

export const createBulkPickSession = {
  name: "createBulkPickSession" as const,
  input: z.object({
    stationId: z.string().optional(),
    filterGroup: FilterGroupSchema.nullish(),
    advancedFiltersData: z.array(AdvancedFilterDataSchema).default([]),
  }),
  output: z.object({
    sessionId: z.string(),
    workOrderCount: z.number(),
    pickLineCount: z.number(),
  }),
};

export const getActiveBulkPickSession = {
  name: "getActiveBulkPickSession" as const,
  input: z.object({ stationId: z.string().optional() }),
  output: z.object({
    session: z
      .object({
        sessionId: z.string(),
        workOrderCount: z.number(),
        pickLineCount: z.number(),
        createdAt: z.string(),
      })
      .nullable(),
  }),
};

export const cancelBulkPickSession = {
  name: "cancelBulkPickSession" as const,
  input: z.object({ sessionId: z.string() }),
  output: z.object({ success: z.boolean() }),
};

export const completeBulkPickSession = {
  name: "completeBulkPickSession" as const,
  input: z.object({ sessionId: z.string() }),
  output: z.object({
    success: z.boolean(),
    resolvedWorkOrderIds: z.array(z.string()).default([]),
  }),
};

export const releaseBulkPickSession = {
  name: "releaseBulkPickSession" as const,
  input: z.object({ sessionId: z.string() }),
  output: z.object({ success: z.boolean() }),
};

export const takeOverBulkPickSession = {
  name: "takeOverBulkPickSession" as const,
  input: z.object({ sessionId: z.string() }),
  output: z.object({ success: z.boolean() }),
};
